"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "berbenno-di-valtellina": {
    "d9a8aab0": [{
      "hkey": "8044dce3",
      "slug": "berbenno-di-valtellina",
      "name": "Berbenno di Valtellina",
      "primary": true,
      "skipSearch": false
    }],
    "foppa": [{
      "hkey": "8044dce3",
      "slug": "berbenno-di-valtellina",
      "name": "Berbenno di Valtellina",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "18e0cd80": [{
      "hkey": "a7e84f5d",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "polaggia": [{
      "hkey": "a7e84f5d",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "berbenno-di-valtellina"
    }],
    "7d82803b": [{
      "hkey": "a7e84f5d",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "regoledo": [{
      "hkey": "a7e84f5d",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "berbenno-di-valtellina"
    }],
    "83accc15": [{
      "hkey": "a7e84f5d",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "san-pietro-berbenno": [{
      "hkey": "a7e84f5d",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "berbenno-di-valtellina"
    }]
  }
};
exports["default"] = _default;